import { MILESTONE_COLORS, MILESTONE_DEFAULT_COLOR } from '../../constants/gantt.const'
import { milestoneLabel } from '../../constants/scheduleList.logic'
import type { ListMilestoneRow } from '../../types/scheduleList.types'

// 마일스톤 행(D-08) — `◆ 이름 · M/D(요일) · D-n`. ◆ 은 마일스톤 색(간트와 같은 MILESTONE_COLORS).
// 표의 첫 칸 안에 그리고, 폭 0 영역에서 오른쪽 빈 칸 위로 글자가 이어지게 한다(열 폭에 영향 없음).
// 마일스톤 추가·수정·삭제 진입은 이 컴포넌트 범위가 아니다(계획서 D-08 '이관확인 후 확정').

export interface ScheduleListMilestoneRowProps {
  milestone: ListMilestoneRow
}

export function ScheduleListMilestoneRow({ milestone }: ScheduleListMilestoneRowProps) {
  const color = MILESTONE_COLORS[milestone.milestoneType ?? ''] ?? MILESTONE_DEFAULT_COLOR
  return (
    <div style={{ width: 0, overflow: 'visible', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 'var(--spacing-03)' }}>
      <span aria-hidden="true" style={{ color, fontSize: 'var(--type-body-sm-size)' }}>◆</span>
      <span style={{ fontSize: 'var(--type-body-sm-size)', fontWeight: 600, color: 'var(--shell-on-surface)' }}>
        {milestoneLabel(milestone)}
      </span>
    </div>
  )
}
